import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * DialysisDragDropQuestion - Content
 *  - A wrapper for DragDropDialysis component in Question Component.
 */
export function Content(props) {
  return (
    <div className="dialysisdragdropquestion_content">{props.children}</div>
  );
}

Content.propTypes = {
  /**
   * The DialysisDragDrop component
   */
  children: PropTypes.element,
};

Content.defaultProps = {};
